/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type DeleteCustomFieldDropdownOptionConfirmationModalQueryVariables = {
    customFieldId?: string | null | undefined;
    hasCustomFieldId: boolean;
};
export type DeleteCustomFieldDropdownOptionConfirmationModalQueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"DeleteCustomFieldDropdownOptionConfirmationModal_viewer">;
    } | null;
};
export type DeleteCustomFieldDropdownOptionConfirmationModalQuery = {
    readonly response: DeleteCustomFieldDropdownOptionConfirmationModalQueryResponse;
    readonly variables: DeleteCustomFieldDropdownOptionConfirmationModalQueryVariables;
};



/*
query DeleteCustomFieldDropdownOptionConfirmationModalQuery(
  $customFieldId: ID
  $hasCustomFieldId: Boolean!
) {
  viewer {
    actualPersonId
    component(name: "custom_field_dropdown_options_modal")
    ...DeleteCustomFieldDropdownOptionConfirmationModal_viewer_2BCQvl @include(if: $hasCustomFieldId)
    id
  }
}

fragment DeleteCustomFieldDropdownOptionConfirmationModal_viewer_2BCQvl on Viewer {
  customFieldDefinition(id: $customFieldId) {
    __typename
    ... on DropdownCustomField {
      options {
        id
        displayName
        isUsed
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customFieldId",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hasCustomFieldId",
    "type": "Boolean!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "custom_field_dropdown_options_modal"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"custom_field_dropdown_options_modal\")"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteCustomFieldDropdownOptionConfirmationModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "condition": "hasCustomFieldId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "customFieldId",
                    "variableName": "customFieldId"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "DeleteCustomFieldDropdownOptionConfirmationModal_viewer"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteCustomFieldDropdownOptionConfirmationModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "condition": "hasCustomFieldId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "customFieldId"
                  }
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "customFieldDefinition",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomFieldDropdownOption",
                        "kind": "LinkedField",
                        "name": "options",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isUsed",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "DropdownCustomField"
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "DeleteCustomFieldDropdownOptionConfirmationModalQuery",
    "operationKind": "query",
    "text": "query DeleteCustomFieldDropdownOptionConfirmationModalQuery(\n  $customFieldId: ID\n  $hasCustomFieldId: Boolean!\n) {\n  viewer {\n    actualPersonId\n    component(name: \"custom_field_dropdown_options_modal\")\n    ...DeleteCustomFieldDropdownOptionConfirmationModal_viewer_2BCQvl @include(if: $hasCustomFieldId)\n    id\n  }\n}\n\nfragment DeleteCustomFieldDropdownOptionConfirmationModal_viewer_2BCQvl on Viewer {\n  customFieldDefinition(id: $customFieldId) {\n    __typename\n    ... on DropdownCustomField {\n      options {\n        id\n        displayName\n        isUsed\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c641b863e2cde6d16b49387990bae22f';
export default node;
